<template>
    <div class="bg-root">
        <TopBarView style="position: relative;z-index: 4;" @about-click="navigateToSection('about')"
            @product-click="navigateToSection('product')" @honor-click="navigateToSection('honor')"
            @app-click="navigateToSection('kkapp')" > </TopBarView>
        <HeadView style="position: relative; z-index: 1;"></HeadView>
        <AboutView id="about" ref="about" style="position: absolute;margin-top: 42.7%; top: 0px; z-index: 2;">
        </AboutView>

        <div
            style="position: absolute;margin-top: 37.8%;margin-left: 83%; top: 0px; z-index: 3;display: flex;flex-direction: column;justify-content: center;align-items: center; ">
            <a href="#about">
                <img class="modeCard" src="../assets/icon/ic_scroll_down.png" style="width: 27px;">
            </a>
            <div style="background-color: white;width: 1px;height: 72px;"></div>
            <span style="color: white;font-size: 12px;margin-top: 10px;">向下滑</span>
        </div>

        <ProductView id="product" ref="product" style="margin-top: 42.7%; top: 0px;"></ProductView>
        <AppView id="kkapp" ref="kkapp" style="margin-top: 15px;"></AppView>
        <HonorView id="honor" ref="honor"></HonorView>
        <FootView @about-click="navigateToSection('about')"
        @product-click="navigateToSection('product')" @honor-click="navigateToSection('honor')" @app-click="navigateToSection('kkapp')"></FootView>


    </div>

</template>
<script setup >
import { onMounted,  } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import TopBarView from '@/components/TopBarView.vue'
import HeadView from '@/components/HeadView.vue'
import AboutView from '@/components/AboutView.vue'
import ProductView from '@/components/ProductView.vue'
import HonorView from '@/components/HonorView.vue'
import FootView from '@/components/FootView.vue'
import AppView from '@/components/AppView.vue'

const route = useRoute()
const router = useRouter()

const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId)
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' })
  }
}

// watch(
//   () => route.query.section,
//   (section) => {
//     if (section) {
//       scrollToSection(section )
//     }
//   }
// )

onMounted(() => {
  const section = route.query.section
  if (section) {
    scrollToSection(section )
  }
})

const navigateToSection = (section) => {
  scrollToSection(section )
  router.replace({ path: '/', query: { section } })
}
</script>


<style setup>
.bg-root {
    position: relative;
}

.modeCard {
    transition: all 0.5s;
}

.modeCard:hover {

    transition: 0.8s;
    transform: scale(1.3);
}
</style>